import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface AISummarizerConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const AISummarizerConfig: React.FC<AISummarizerConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="AI Összefoglaló">
        <ConfigField
          label="Összefoglalandó szöveg"
          description="A hosszú szöveg amit össze kell foglalni"
        >
          <textarea
            value={node.data.config?.text || ''}
            onChange={(e) => updateConfig('text', e.target.value)}
            placeholder="{{article}} vagy közvetlen szöveg..."
            rows={6}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <ConfigField
          label="Összefoglaló hossza"
          description="Milyen hosszú legyen az összefoglaló"
        >
          <select
            value={node.data.config?.summaryLength || 'medium'}
            onChange={(e) => updateConfig('summaryLength', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="short">Rövid (1-2 mondat)</option>
            <option value="medium">Közepes (3-5 mondat)</option>
            <option value="long">Hosszú (1 bekezdés)</option>
            <option value="detailed">Részletes (több bekezdés)</option>
          </select>
        </ConfigField>

        <ConfigField
          label="Összefoglaló stílusa"
          description="Milyen stílusban"
        >
          <select
            value={node.data.config?.style || 'neutral'}
            onChange={(e) => updateConfig('style', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="neutral">Semleges</option>
            <option value="bullet">Felsorolás</option>
            <option value="executive">Vezetői összefoglaló</option>
            <option value="technical">Technikai</option>
          </select>
        </ConfigField>

        <ConfigField
          label="AI Provider"
          description="Melyik AI szolgáltatást használja"
        >
          <select
            value={node.data.config?.provider || 'openai'}
            onChange={(e) => updateConfig('provider', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="openai">OpenAI</option>
            <option value="claude">Claude</option>
            <option value="gemini">Gemini</option>
          </select>
        </ConfigField>

        <ConfigField
          label="API Kulcs"
          description="AI szolgáltatás API kulcsa"
        >
          <input
            type="password"
            value={node.data.config?.apiKey || ''}
            onChange={(e) => updateConfig('apiKey', e.target.value)}
            placeholder="sk-..."
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="includeKeyPoints"
            checked={node.data.config?.includeKeyPoints !== false}
            onChange={(e) => updateConfig('includeKeyPoints', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="includeKeyPoints" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Kulcspontok kiemelése
          </label>
        </div>
      </ConfigSection>

      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md p-3">
        <div className="text-xs text-green-700 dark:text-green-300">
          <strong>📄 AI Összefoglalás:</strong>
          <br />• Hosszú szövegek automatikus összefoglalása
          <br />• Eredmény: <code>{'{{summary}}'}</code>
          <br />• Tömörítési arány: <code>{'{{compression_ratio}}'}</code>
          <br />• Példa: Cikk, dokumentum, email összefoglalás
        </div>
      </div>
    </div>
  );
};

export default AISummarizerConfig;
